import styled from '@emotion/styled';

import { TextSmall } from '../../../common/text/TextSmall';
import { useSectionContext } from '../../../list-box/ListBox';

import { cssUtil } from '../../../../theme/cssUtil';
import { su } from '../../../../theme/functions/su';
import { theme } from '../../../../theme/theme';

export function GridSection(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { section, state, item, value, children } = useSectionContext();

  return (
    <GridSection.Root as={props.as} {...section.itemProps}>
      {item.rendered && (
        <GridSection.Heading
          {...section.headingProps}
          lineHeight="20px"
          color={theme.color.text_light}
        >
          {item.rendered}
        </GridSection.Heading>
      )}
      <GridSection.Children {...section.groupProps}>{children}</GridSection.Children>
    </GridSection.Root>
  );
}

GridSection.Heading = styled(TextSmall)`
  margin-inline-start: ${su(1)};
  margin-bottom: ${su(1)};
`;

GridSection.Root = styled.li`
  margin-bottom: ${su(2)};
`;

GridSection.Children = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${su(1)};
  margin: ${su(-1)};
  list-style: none;

  @media only screen and (min-width: ${cssUtil.viewport.medium}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
